import { Injectable } from '@angular/core';

import { Resolve } from '@angular/router';
import {Observable} from 'rxjs';
import {User} from '../User';
import {ApiService, SoftwaresList} from '../api/api.service';

@Injectable()
export class SoftwaresResolver implements Resolve<Observable<SoftwaresList>> {

  constructor(private api: ApiService) {}

  resolve() {
    return this.api.getSoftwaresList()
  }
}
